import * as React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { Button, ButtonGroup } from "reactstrap";
import { bindActionCreators } from "redux";
import {
  alertAction,
  ordersAction,
  licencesAction,
  orderAction,
  licenceAction,
  systemsAction
} from "../../_actions";
import i18next from "i18next";

import { MainMenu, AccountMenu, CzechFlag, USAFlag } from ".";

class SidePanel extends React.Component<any, any> {
  changeLanguage(lang: any) {
    i18next.changeLanguage(lang);
    this.props.reloadOrders;
    this.props.reloadLicences;
    this.props.reloadOrder;
    this.props.reloadLicence;
    this.props.reloadSystems;
  }

  render() {
    return (
      <>
      {/* {this.props.authentication.authenticated && ( */}
        <aside className="left-panel">
          <div style={{position: "fixed"}}>
            <Link className="brand" to="/">
              <h1>sypal</h1>
            </Link>
            {this.props.authentication.authenticated && (
              <>
                <MainMenu />
                <AccountMenu
                  authentificated={this.props.authentication.authenticated}
                />
              </>
            )}
          </div>
          <ul className="menu languages row mx-0" style={{bottom: "0", position: "fixed"}}>
            <li
              className="pointer-cursor col-xl-6 p-0"
              onClick={() => this.changeLanguage("cs")}
            >
              <a className="menu-link">
                <div>
                  <i className="p-0 m-auto">
                    <CzechFlag />
                  </i>
                </div>
              </a>
            </li>
            <li
              className="pointer-cursor col-xl-6 p-0"
              onClick={() => this.changeLanguage("en")}
            >
              <a className="menu-link">
                <div>
                  <i className="p-0 m-auto">
                    <USAFlag />
                  </i>
                </div>
              </a>
            </li>
          </ul>
        </aside>
        {/* )} */}
      </>
    );
  }
}

const mapStateToProps = (state: any) => {
  return { authentication: state.authentication };
};

const mapDispatchToProps = (dispatch: any) => {
  return bindActionCreators(
    {
      show: alertAction.show,
      hide: alertAction.hide,
      reloadOrders: ordersAction.loadOrders,
      reloadLicences: licencesAction.loadLicences,
      reloadOrder: orderAction.loadOrder,
      reloadLicence: licenceAction.loadLicence,
      reloadSystems: systemsAction.loadSystems
    },
    dispatch
  );
};

const SidePanelComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(SidePanel);

export { SidePanelComponent as SidePanel };
